import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import MaintenanceAdd from './MaintenanceAdd.vue'
import { MaintainProjectServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
const mpjsp = new MaintainProjectServiceProxy()

@Component({
  components: {
    MaintenanceAdd
  }
})
export default class Maintenance extends Vue { // 保养项目
  @Prop({ default: false }) readonly loading: Boolean
  @Prop({ default: () => ([]) }) readonly data: Array<any>;

  get subColumns() {
    return [
      { title: this.$t('page_plan_maintenance_maintenance_item_code'), dataIndex: 'itemCode', width: 150, ellipsis: true },
      { title: this.$t('page_plan_maintenance_items'), dataIndex: 'itemName', width: 200, ellipsis: true },
      { title: this.$t('page_plan_maintenance_requirements'), dataIndex: 'itemRequirement', width: 100, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'itemRemark', width: 200, ellipsis: true }
    ]
  }

  render() {
    return (
      <div style="height: 260px;">
        <ml-table
          size="small"
          defaultExpandAllRows={true}
          canChangeColWidth={true}
          loading={this.loading}
          dataSource={this.data}
          columns={this.subColumns}
          scroll={{ y: 200 }}
        ></ml-table>
      </div>
    )
  }
}
